// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../phoenix-app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container--3bJ75{position:absolute;left:0;top:0}", ""]);
// Exports
exports.locals = {
	"container": "container--3bJ75"
};
module.exports = exports;
